var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18H14.25C13.8 18 13.5 17.7 13.5 17.25C13.5 16.8 13.8 16.5 14.25 16.5H17.25C17.7 16.5 18 16.8 18 17.25C18 17.7 17.7 18 17.25 18Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18C16.8 18 16.5 17.7 16.5 17.25V14.25C16.5 13.8 16.8 13.5 17.25 13.5C17.7 13.5 18 13.8 18 14.25V17.25C18 17.7 17.7 18 17.25 18ZM3.75 1.5H0.75C0.3 1.5 0 1.2 0 0.75C0 0.3 0.3 0 0.75 0H3.75C4.2 0 4.5 0.3 4.5 0.75C4.5 1.2 4.2 1.5 3.75 1.5Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.5C0.3 4.5 0 4.2 0 3.75V0.75C0 0.3 0.3 0 0.75 0C1.2 0 1.5 0.3 1.5 0.75V3.75C1.5 4.2 1.2 4.5 0.75 4.5Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 6.60039C5.625 6.60039 5.475 6.52539 5.325 6.37539L0.375 1.42539C0.075 1.12539 0.075 0.675391 0.375 0.375391C0.675 0.0753906 1.125 0.0753906 1.425 0.375391L6.3 5.25039C6.6 5.55039 6.6 6.00039 6.3 6.30039C6.225 6.52539 6 6.60039 5.85 6.60039ZM17.1 17.8504C16.875 17.8504 16.725 17.7754 16.575 17.6254L11.7 12.7504C11.4 12.4504 11.4 12.0004 11.7 11.7004C12 11.4004 12.45 11.4004 12.75 11.7004L17.625 16.5754C17.925 16.8754 17.925 17.3254 17.625 17.6254C17.475 17.7754 17.25 17.8504 17.1 17.8504ZM0.75 18.0004C0.3 18.0004 0 17.7004 0 17.2504V14.2504C0 13.8004 0.3 13.5004 0.75 13.5004C1.2 13.5004 1.5 13.8004 1.5 14.2504V17.2504C1.5 17.7004 1.2 18.0004 0.75 18.0004Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18H0.75C0.3 18 0 17.7 0 17.25C0 16.8 0.3 16.5 0.75 16.5H3.75C4.2 16.5 4.5 16.8 4.5 17.25C4.5 17.7 4.2 18 3.75 18ZM17.25 4.5C16.8 4.5 16.5 4.2 16.5 3.75V0.75C16.5 0.3 16.8 0 17.25 0C17.7 0 18 0.3 18 0.75V3.75C18 4.2 17.7 4.5 17.25 4.5Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 1.5H14.25C13.8 1.5 13.5 1.2 13.5 0.75C13.5 0.3 13.8 0 14.25 0H17.25C17.7 0 18 0.3 18 0.75C18 1.2 17.7 1.5 17.25 1.5Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1484 6.59961C11.9234 6.59961 11.7734 6.52461 11.6234 6.37461C11.3234 6.07461 11.3234 5.62461 11.6234 5.32461L16.4984 0.449609C16.7984 0.149609 17.2484 0.149609 17.5484 0.449609C17.8484 0.749609 17.8484 1.19961 17.5484 1.49961L12.6734 6.37461C12.5984 6.52461 12.3734 6.59961 12.1484 6.59961ZM0.898438 17.8496C0.673437 17.8496 0.523438 17.7746 0.373438 17.6246C0.0734375 17.3246 0.0734375 16.8746 0.373438 16.5746L5.24844 11.6996C5.54844 11.3996 5.99844 11.3996 6.29844 11.6996C6.59844 11.9996 6.59844 12.4496 6.29844 12.7496L1.42344 17.6246C1.27344 17.7746 1.12344 17.8496 0.898438 17.8496Z",
    fill: "#E1E1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.639d029b9f992875746a641ffd02fe10.svg";
export { ForwardRef as ReactComponent };